import * as React from "react";

// @ts-ignore
import useMicrofrontend from "../../../utils/hooks/useMicrofrontend";
import config from "../../../utils/config";

export interface FooterProps {
    eosContentUrl?: string;
}

export const Footer = (props: FooterProps) => {
    const id = "eos-footer";
    const configUrl = props.eosContentUrl ? props.eosContentUrl : config.eosContentUrl;
    // @ts-ignore
    const { isLoaded, eosContent } = useMicrofrontend("eosContent", configUrl);

    React.useEffect(() => {
        if (!eosContent) return;
        const { render, unMount } = eosContent;
        render(id);

        return () => unMount(id);
    }, [isLoaded]); // eslint-disable-line

    if (!isLoaded) return null;
    if (!eosContent) return <div id="missing-footer" />;

    return <div id={id} />;
};
